import styled from "styled-components";

export const AccordionContainer = styled.div`
  position: relative;

  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto;
  row-gap: 40px; // ?

  font-family: ${({ theme }) => theme.fontFamilies.secondary};

  ${({ theme }) => theme.mediaQueries.tablet} {
    grid-template-columns: repeat(12, 1fr);
  }
  ${({ theme }) => theme.mediaQueries.laptop} {
    padding-left: 1.5rem;
  }
`;

export const AccordionInner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;

  ${({ theme }) => theme.mediaQueries.tablet} {
    grid-column: 1 / span 12;
  }
`;
